import { TextField } from "@mui/material";

const FormTextField = ({ sx = {}, InputLabelProps = {}, inputRef, value, ...props }) => {
  return (
    <TextField
      {...props}
      value={value ?? ""}
      inputRef={inputRef}
      variant="outlined"
      fullWidth
      InputLabelProps={{
        ...InputLabelProps,
        ...(InputLabelProps.sx ? { sx: InputLabelProps.sx } : {}),
      }}
      sx={{
        "& .MuiInputLabel-root": {
          top: "50%",
          transform: "translateY(-50%)",
          left: "16px",
          transition: "all 200ms ease",
          pointerEvents: "none",
          "&.Mui-focused, &.MuiInputLabel-shrink": {
            top: -9,
            transform: "translateY(0) scale(0.75)",
            backgroundColor: "#fff",
            padding: "0 6px",
            zIndex: 1,
            marginLeft: "-4px",
          },
        },
        "&:has(input:-webkit-autofill) .MuiInputLabel-root, &:has(input:not(:placeholder-shown)) .MuiInputLabel-root": {
          top: -9,
          transform: "translateY(0) scale(0.75)",
          backgroundColor: "#fff",
          padding: "0 6px",
          zIndex: 1,
          marginLeft: "-4px",
        },
        "& .MuiOutlinedInput-root": {
          height: "50px",
          borderRadius: "10px",
          "& input": {
            color: "#333",
          },
          "&:hover fieldset": {
            borderColor: "gray",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#CDCDCF",
          },
          "& input:-webkit-autofill": {
            WebkitTextFillColor: "#333 !important",
            caretColor: "#333 !important",
          },
          "& input:-internal-autofill-selected": {
            color: "#333",
          },
          ...(sx["& .MuiOutlinedInput-root"] || {}),
        },
        ...sx,
      }}
    />
  );
};

export default FormTextField;
